<template>
    <v-row class="no-frame pt-2">
        <v-col class="col-3  no-border pr-2" >
            <div class="stamp-col" v-if="bidStamps">
                <f-stamp-upload
                    v-for             = "stamp in bidStamps"
                    :key              = "stamp.id"
                    :stamp            = "stamp"
                    :image            = "getImage (stamp.id)"
                    :min-image-height = "120"
                    :show-text-input  = "true"
                    @drop             = "onDrop"
                    @save             = "onSave"
                    class             = "upload-frame mb-4"
                />
            </div>
        </v-col>
        <v-col class="col-3 pl-2 pr- 2 no-border " >
            <div class="stamp-col" v-if="invoiceStamps">
                <f-stamp-upload
                    v-for             = "stamp in invoiceStamps"
                    :key              = "stamp.id"
                    :stamp            = "stamp"
                    :image            = "getImage (stamp.id)"
                    :min-image-height = "120"
                    :show-text-input  = "true"
                    @drop             = "onDrop"
                    @save             = "onSave"
                    class             = "upload-frame mb-4"
                />
            </div>
        </v-col>
        <v-col class="col-3 pl-2 pr-2 no-border ">
            <v-row class="no-frame">

            </v-row>
        </v-col>
        <v-col class="col-3 pl-2 no-border ">
            <v-row class="no-frame">
                <p-user-stamps
                    v-if="privileged"
                />
            </v-row>
        </v-col>
    </v-row>
</template>

<script>

import Core         from "@/modules/core/service/Core";
import Msd          from "@/modules/msd/common/service/Msd";
import PUserStamps  from "@/modules/msd/preferences/components/main/private/PUserStamps.vue";
import FStampUpload from "@/modules/core/components/utils/FStampUpload.vue";

export default {
    name: "CPreferencesDetailsStamp",

    components: {
        FStampUpload,
        PUserStamps,
    },

    data: () => ({
        drag: false,
        showMessage: false,
        message    : null,
        images     : [],
        stamps     : null
    }),

    computed: {
        invoiceStamps () {
            if (!this.stamps) {
                return null;
            }

            return this.stamps.filter(s => s.tag.startsWith("INVOICE"));
        },

        bidStamps () {
            if (!this.stamps) {
                return null;
            }

            return this.stamps.filter(s => s.tag.startsWith('BID'));
        },

        privileged () {
            return Core.role.privileged();
        },
    },

    mounted() {
        this.load ();
    },

    methods: {
        onDrop (event) {
            this.upload (event.id, event.file);
        },

        onSave (event) {
            Msd.globalstamp.save(event.stamp).then(() => {
                Core.message.alert.save(this);
                if (event.callback) {
                    event.callback ();
                }
            });
        },

        getImage (id) {
            const stamp = this.images.find(i => i.id === id);
            if (!stamp) {
                return null;
            }

            return stamp.data;
        },

        upload(type, file) {
            console.log("upload")
            Msd.globalstamp.upload(type, file, (data) => {
                const index = this.images.findIndex(i => i.id === type);
                if (index >= 0) {
                    this.images[index].data = data;
                }
            }, (message) => {
                this.message = message;
                this.showMessage = true;
            });
        },

        load () {
            Msd.globalstamp.loadAll().then (stamps => {
                console.log("load", stamps)
                this.stamps = stamps;
                this.stamps.forEach(stamp => {
                    Msd.globalstamp.load(stamp.id, (data => {
                        this.images.push ({
                            id: stamp.id,
                            data: data
                        });
                    }));
                })
                console.log("images", this.images)
            })
        }
    }
}
</script>

<style scoped>

.stamp-col {
    overflow-y: scroll;
    max-height: 900px;
}

</style>